const MuiAvatar = {
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            })
    }
};
export { MuiAvatar };

//# sourceMappingURL=avatar-overrides.js.map